import React, { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export const LanguageSwitcher = ({ dark = false }) => {
  const { lang, setLang, langs } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = langs.find((l) => l.code === lang);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 text-sm font-medium ${dark ? "text-white/90" : "text-gray-700 hover:text-brand-red"}`}
        data-testid="lang-switcher">
        <Globe size={16} /> {current?.short}
        <ChevronDown size={13} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 shadow-lg z-50">
          {langs.map((l) => (
            <button key={l.code} onClick={() => { setLang(l.code); setOpen(false); }}
              className={`block w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 ${lang === l.code ? "text-brand-red font-semibold" : "text-gray-700"}`}
              data-testid={`lang-${l.code}`}>
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
